const React = require('react')
const PropTypes = require('prop-types')
const withStyles = require('withStyles').default
const styles = require('./signup_buttons.less')
const SvgInline = require('react-svg-inline').default
const FacebookIcon = require('!!raw-loader!images/social/facebook.svg')
const GoogleIcon = require('!!raw-loader!images/social/google.svg')
const radio = require('lib/radio')
const funnels = require('lib/funnels')
const log = require('log').create('home-signupbutton') // eslint-disable-line

function ButtonText({ variant }) {
    switch (variant) {
        case 'from_profile':
            return (
                <span>Get started for free</span>
            )
        default:
            return (
                <span>Get your free page</span>
            )
    }
}
ButtonText.propTypes = {
    variant: PropTypes.string,
}


class SignupButtons extends React.Component {

    componentDidMount() {
        this.channel = radio.auth
    }

    componentDidUpdate() {
        this.enableButton()
    }

    onClickEmail(e) {
        if (this.allowEmailSignup()) this.channel.trigger('click:signup:email')
        else window.location = '/signup/start'
    }

    onClickFacebook(e) {
        this.channel.trigger('click:signup:facebook')
    }

    onClickGoogle(e) {
        this.channel.trigger('click:signup:google')
    }

    allowEmailSignup() {
        return funnels.get('20210903_no_email_signup').is('control')
    }

    enableButton() {
        if (! this.allowEmailSignup()) return

        // This part is a little tricky and temporate solution before moving signupbutton logic to react
        // We have to control the class other than re-render because we have to load the google element first
        // event they might not be able to use afterwards
        const { enable_facebook, enable_google } = this.props
        if (! enable_google && ! enable_facebook) return

        this.or_signup.classList.remove('not-ready')

        if (enable_facebook) this.facebook.classList.remove('not-ready')
        if (enable_google) this.google.classList.remove('not-ready')
    }

    render() {
        const { variant, button_rank, button_luminance } = this.props
        const btn_class = `button large ${button_rank} ${button_luminance} email`

        return (
            <div className="signup-buttons-widget">
                <div className="signup-buttons">
                    <button type="button" className={btn_class} onClick={(e) => { this.onClickEmail(e) }}>
                        <ButtonText variant={variant} />
                    </button>
                </div>

                {this.allowEmailSignup() && <React.Fragment>
                    <p className="or-signup not-ready" ref={(el) => { this.or_signup = el }}>
                        or sign up with
                    </p>
                    <p>
                        <button
                            type="button"
                            ref={(el) => { this.facebook = el }}
                            className="button light quaternary small social-button facebook not-ready"
                            onClick={(e) => { this.onClickFacebook(e) }}
                            >
                            <SvgInline
                                component="span"
                                className="social-icon"
                                svg={FacebookIcon}
                                />
                            Facebook
                        </button>
                        <button
                            type="button"
                            ref={(el) => { this.google = el }}
                            className="button light quaternary small social-button google not-ready"
                            onClick={(e) => { this.onClickGoogle(e) }}
                            >
                            <SvgInline
                                component="span"
                                className="social-icon"
                                svg={GoogleIcon}
                                />
                            Google
                        </button>
                    </p>
                </React.Fragment>}
            </div>
        )
    }
}

SignupButtons.propTypes = {
    button_rank: PropTypes.oneOf([
        'primary',
        'secondary',
        'tertiary',
        'quaternary',
    ]).isRequired,
    button_luminance: PropTypes.oneOf([
        'light',
        'dark',
    ]).isRequired,
    enable_facebook: PropTypes.bool,
    enable_google: PropTypes.bool,
    variant: PropTypes.string,
}

module.exports = withStyles(styles)(SignupButtons)
